module.exports = __webpack_public_path__ + "static/media/notificacion_categoria_importaciones.95673710.png";